import type { ListItemLabelCreationPanelFragment } from "../../client/generated";
import { useCreateListItemLabelFromPanelMutation } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";

type Props = {
  fragment: ListItemLabelCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function ListItemLabelCreationPanel({ fragment, onDelete }: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateListItemLabelFromPanelMutation();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("ListItemLabelCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
